
import { Component, Vue } from 'vue-property-decorator'
import { UserClient, GroupClient, RoleClient } from '@/api'
import { IRoleData } from '@/api/types'
import UserEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'

@Component({
  name: 'UserList',
  components: {
    UserEditor
  },
  filters: {
    formatStation(station: any) {
      return station ? station.name : '选择所属加气站'
    },
    formatCompany(company: any) {
      return company ? company.name : '选择所属企业'
    },
    formatGroups(groups: any, groupList: any) {
      let result = ''
      const groupCollection = JSON.parse(groups)
      if (groupCollection && groupCollection.length > 0) {
        for (const item of groupCollection) {
          const g = _.find(groupList, (o) => { return Number(o.id) === Number(item) })
          result += result === '' ? '' : '<br/>'
          result += `${g.name}(${g.description})`
        }
      }
      result += result === '' ? '尚未选择用户组' : ''
      return result
    }
  }
})
export default class extends BaseList {
  protected groupClient: GroupClient
  protected groupList=[]

  private roleList=[];
  private roleClient = new RoleClient();
  public constructor() {
    super()
    this.client = new UserClient()
    this.groupClient = new GroupClient()

    this.listQuery = {
      filter: {
        where: { name: { like: '' } },
        // fields: {
        //   id: true,
        //   name: true,
        //   username: true,
        //   avatar: true,
        //   roleId: true,
        //   stationId: true,
        //   companyId: true,
        //   createdAt: true
        // },
        include: [
          { relation: 'role' },
          { relation: 'station' },
          { relation: 'company' }
        ],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt']
      }
    }
  }

  async created() {
    super.created()
    await this.getGroupList()
    await this.getRoleList()
  }

  private async getRoleList() {
    this.roleList = await this.roleClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          description: true
        },
        order: ['createdAt']
      }
    })
  }

  protected async getGroupList() {
    this.listLoading = true
    this.groupList = await this.groupClient.fetch({})
    this.listLoading = false
  }

  protected generateQuery(): any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    if (_.isNil(t.filter.where.roleId) || _.isEqual(t.filter.where.roleId, '')) {
      delete t.filter.where.roleId
    }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val: number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val: number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: IRoleData) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: IRoleData) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
}
